import React, { useState } from 'react';
import { Lock, Mail, ShieldCheck, UserRound } from 'lucide-react';
import { authService } from '../services/authService';
import './AdminPortal.css';

const portalBenefits = [
  'Registered member directory',
  'Plan and payment visibility',
  'Protected admin-only access',
];

const AdminLoginPage = ({ onAuthenticated }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const submitLogin = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError('');
    try {
      const user = await authService.login({ email, password, role: 'admin' });
      onAuthenticated?.(user);
    } catch (requestError) {
      setError(requestError.message || 'Invalid admin credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="admin-login-page">
      <aside className="admin-login-intro">
        <div className="admin-login-logo"><ShieldCheck size={34} /></div>
        <div>
          <h1>MindVrik</h1>
          <p>Admin Portal</p>
        </div>
        <div className="admin-login-benefits">
          {portalBenefits.map((item) => (
            <div key={item}><ShieldCheck size={18} />{item}</div>
          ))}
        </div>
      </aside>
      <main className="admin-login-form-wrap">
        <form className="admin-login-form" onSubmit={submitLogin}>
          <div className="admin-login-heading">
            <span>SECURE ACCESS</span>
            <h2>Admin Sign In</h2>
            <p>Enter your administrator credentials to access the portal.</p>
          </div>
          {error && <div className="admin-form-error">{error}</div>}
          <label>Email Address
            <div className="admin-input"><Mail size={19} /><input required type="email" value={email} onChange={(event) => setEmail(event.target.value)} placeholder="admin@company.com" /></div>
          </label>
          <label>Password
            <div className="admin-input"><Lock size={19} /><input required type="password" value={password} onChange={(event) => setPassword(event.target.value)} placeholder="Your password" /></div>
          </label>
          <button className="admin-primary-button" type="submit" disabled={loading}>
            <UserRound size={18} />{loading ? 'Signing in...' : 'Sign In to Admin Portal'}
          </button>
          <p className="admin-login-note">Admin access only. Contact the platform owner for credentials.</p>
        </form>
      </main>
    </section>
  );
};

export default AdminLoginPage;
